import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const _preActionName = Pre.LIGHT;

export function toggleSwitch(deviceId, accessToken) {
  return {
    type: _preActionName + Actions.TOGGLE_SWITCH,
    accessToken: accessToken,
    payload: { deviceId },
    socket: { send: true, keepSocket: true },
  };
}

export function turnOn(deviceId = 0, deviceUId = null, accessToken) {
  var payload = { deviceId, deviceUId, value: true };

  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function turnOff(deviceId, deviceUId, accessToken) {
  var payload = { deviceId, deviceUId, value: false };

  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}
